import React from "react";
import { Phone, MessageSquareText, CalendarCheck, ArrowRight } from "lucide-react";
import { DBR, CONTACT_PHONE_HREF } from "../mock";
import { useReveal } from "../hooks/useReveal";

const STEP_ICONS = [Phone, MessageSquareText, CalendarCheck];

export default function DatabaseReactivation() {
  const r = useReveal();
  return (
    <section id="reactivation" className="bg-ls-alt py-20 md:py-28 border-t" style={{ borderColor: "var(--ls-border)" }}>
      <div ref={r.ref} className={`max-w-7xl mx-auto px-5 md:px-8 ${r.className}`}>
        <div className="max-w-3xl">
          <p className="ls-eyebrow mb-4">{DBR.eyebrow}</p>
          <h2 className="font-display text-white text-[9vw] sm:text-5xl md:text-6xl">
            {DBR.headline.split("booked jobs")[0]}
            <span className="text-orange">booked jobs.</span>
          </h2>
          <p className="mt-5 text-lg text-[#b7ab9b] leading-relaxed">{DBR.body}</p>
        </div>

        {/* Steps */}
        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {DBR.steps.map((s, i) => {
            const Icon = STEP_ICONS[i] || Phone;
            return (
              <div key={s.n} className="card-dark p-6">
                <div className="flex items-center justify-between mb-4">
                  <span
                    className="flex items-center justify-center w-11 h-11 rounded-[6px]"
                    style={{ backgroundColor: "rgba(242,106,33,0.12)" }}
                  >
                    <Icon className="w-5 h-5 text-orange" />
                  </span>
                  <span className="big-index text-4xl opacity-40">{s.n}</span>
                </div>
                <h3 className="font-cond font-extrabold text-xl text-white uppercase tracking-wide">{s.title}</h3>
                <p className="mt-2 text-[#b7ab9b] leading-relaxed">{s.body}</p>
              </div>
            );
          })}
        </div>

        {/* Stat band */}
        <div
          className="mt-6 rounded-lg grid grid-cols-3 divide-x overflow-hidden"
          style={{ background: "var(--ls-surface)", border: "1px solid var(--ls-border)", borderColor: "var(--ls-border)" }}
        >
          {DBR.stats.map((st, i) => (
            <div key={i} className="p-6 text-center" style={{ borderColor: "var(--ls-border)" }}>
              <div className="font-display text-4xl md:text-5xl text-orange leading-none">{st.value}</div>
              <div className="text-xs md:text-sm text-[#b7ab9b] uppercase tracking-[0.12em] mt-2">{st.label}</div>
            </div>
          ))}
        </div>

        <div className="mt-8">
          <a href={CONTACT_PHONE_HREF} className="btn-orange text-base">
            Reactivate My List <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
